import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid, makeStyles } from "@material-ui/core";
import { Redirect } from "react-router-dom";
import LoginForm from "./components/login-form";
import { getLoginRolesList } from "../../actions/actions-loginroles";
import {
	getLogin,
	updateLogin,
	// deleteLogin,
	// deactivateLogin,

	/*** SPECIFIC TO THIS APP --- START */
	loginAssignProgram,
	loginUnAssignProgram,
	/*** SPECIFIC TO THIS APP  --- END */
} from "../../actions/actions-logins";

/*** SPECIFIC TO THIS APP */
import {
	getProgramsAssignedToLoginList,
	getProgramsNOTAssignedToLoginList,
} from "actions/actions-programs";
import { getDropDownsList } from "actions/actions-drop-downs";
import { PROGRAMS_TABLE, GET_PROGRAMS_LIST } from "actions/action-constants";
/*** SPECIFIC TO THIS APP */

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(4),
	},
}));
const LoginEdit = (props) => {
	const classes = useStyles();
	/*** this is the old container --- start */
	const dispatch = useDispatch();

	const loginrolesList = useSelector((state) => state.loginroles);
	const loginsList = useSelector((state) => state.logins);
	const programsList = useSelector((state) => state.programsR);

	const { errors, errorInvalidEntry, login } = loginsList;
	const { loginroles } = loginrolesList;
	const { programsassignedtologin, programsnotassignedtologin } = programsList;

	/*** this is the old container --- end */
	/*** this is the old componentDidMount - aka onLoad - you can have multiple useEffects --- start */
	useEffect(() => {
		dispatch(getLoginRolesList());
		dispatch(getLogin(props.match.params.id));

		/*** SPECIFIC TO THIS APP --- START */
		var paramsP = { tablename: PROGRAMS_TABLE };
		dispatch(getDropDownsList(paramsP, GET_PROGRAMS_LIST));
		dispatch(getProgramsAssignedToLoginList(props.match.params.id));
		dispatch(getProgramsNOTAssignedToLoginList(props.match.params.id));
		/*** SPECIFIC TO THIS APP --- END */

	}, [dispatch]);
	/*** this is the old componentDidMount - aka onLoad - you can have multiple useEffects --- end */

	/*** redirect and send to list screen if id doesnt exist */
	if (errorInvalidEntry) {
		console.log("fix the /logins redirect here ...");
		return <Redirect to="/logins" />;
	}

	const saveEntry = (id, params) => {
		dispatch(updateLogin(id, params)).then(() =>
			props.history.push("/logins/")
		);
	};

	// const Login_Deactivate = (id, params) => {
	//     dispatch(deactivateLogin(id, params)).then(() =>
	//       ownProps.history.push('/logins')
	//     );
	// }

	// const Login_Delete = (id, description) => {
	//   dispatch(deleteLogin(id, description)).then(
	//     ownProps.history.push('/logins')
	//   );
	// };

	const UnAssignProgram_to_Login = (params, id) => {
		if ((params.programid > 0) && (params.programid > 0)) {
			dispatch(loginUnAssignProgram(params))
				.then(() => dispatch(getProgramsAssignedToLoginList(id)))
				.then(() => dispatch(getProgramsNOTAssignedToLoginList(id)));
		}
	};

	const AssignProgram_to_Login = (params, id) => {
		if ((params.programid > 0) && (params.programid > 0)) {
			dispatch(loginAssignProgram(params))
				.then(() => dispatch(getProgramsAssignedToLoginList(id)))
				.then(() => dispatch(getProgramsNOTAssignedToLoginList(id)));
		}
	};

	return (
		<div className={classes.root}>
			<Grid container spacing={4}>
				<Grid item xs={12}>
					<LoginForm
						{...props}
						componentMode={1}
						initialValues={login}
						loginroles={loginroles}
						errors={errors}
						errorInvalidEntry={errorInvalidEntry}
						saveEntry={saveEntry}
						// deleteEntry={Login_Delete}
						// deactivateLogin={Login_Deactivate}

						/*** SPECIFIC TO THIS APP --- START */

						programsAssigned={programsassignedtologin}
						programsNotAssigned={programsnotassignedtologin}
						loginAssignProgram={AssignProgram_to_Login}
						loginUnAssignProgram={UnAssignProgram_to_Login}

						/*** SPECIFIC TO THIS APP  --- END */

					/>
				</Grid>
			</Grid>
		</div>
	);
};
export default LoginEdit;
